import PropTypes from 'prop-types';

import ReactPlayer from 'react-player';


import { parseTitle } from '../../../utils/title-parser';
import { Shapes } from '../shared';
import useResponsive from '../../../utils/responsive';


const VideoSection = (props) => {
    const { videoUrl } = props;
    
    const { isMobile } = useResponsive();

    if (!videoUrl) {
        return (
            <div className='video-section-empty-space' />
        );
    }

    return (

        <div className='video-section-video-div'>

            <div className={`container-root video-section-heading-container ${ props.isHome ? 'container-root-maxWidthLg' : 'container-root-maxWidthMd'}`}>

                {!props.isHome && props.title && (
                    <div>
                        <h2
                            className={
                                props.isPartners
                                    ? 'video-section-partners-center-headings'
                                    : 'video-section-center-headings'
                            }
                        >
                            {props.title}
                        </h2>
                    </div>
                )}
                {props.isHome && (
                    <div>
                        <h1 className='video-section-title'>
                            {parseTitle(props.title, 'video_section_header')}
                        </h1>
                        <h4 className='video-section-sub-heading'>{props.subHeading}</h4>
                    </div>
                )}
            </div>

            <div className='container-root container-root-maxWidthLg'>

                <div className='video-section-video-container'>

                    <div className='video-section-dots-container'>
                        <Shapes
                            isDots
                            isSquare
                            speed={0.03}
                            containerMargins={{ top: isMobile ? '-60%' : '-20%', left: '0%' }}
                            smallMargins={{ width: '30%', height: '40%' }}
                            zIndex={5}
                        />
                    </div>

                    <ReactPlayer
                        className="react-player"
                        url={videoUrl}
                        playing={false}
                        width="100%"
                        height={isMobile ? 180 : 740}
                        controls
                    />

                </div>

            </div>

        </div>
    );
};

export default VideoSection;

VideoSection.propTypes = {
    title: PropTypes.string,
    subHeading: PropTypes.string,
    videoUrl: PropTypes.string,
    isHome: PropTypes.bool,
    isPartners: PropTypes.bool,
};
